<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta">
    <div class="header-with-cta without-border">
      <div class="cta-wrapper">
        <button nz-button nzType="primary" (click)="addQuestion()">
          New Question
        </button>
      </div>
    </div>
    <form nz-form class="form" nzLayout="horizontal" [formGroup]="getFormGroup">
      <nz-table
        #sortTable
        nzShowSizeChanger
        [nzData]="questionList"
        [nzFrontPagination]="false"
        [nzTotal]="totalRows || 0"
        [(nzPageIndex)]="pageIndex"
        [nzPageSize]="pageSize"
        (nzQueryParams)="onQueryParamsChange($event)"
        [nzScroll]="{ x: '1200', y: 'calc(100vh - 354px)' }">
        <thead>
          <tr>
            <th scope="col" nzWidth="300px" [title]="listOfColumn[0].title">
              {{ listOfColumn[0].title }}
            </th>

            <th
              scope="col"
              nzAlign="center"
              nzWidth="100px"
              nzAlign="center"
              [title]="listOfColumn[1].title">
              {{ listOfColumn[1].title }}
            </th>
            <th
              scope="col"
              nzWidth="90px"
              nzAlign="center"
              [title]="listOfColumn[2].title">
              {{ listOfColumn[2].title }}
            </th>
            <th
              scope="col"
              nzWidth="120px"
              nzAlign="center"
              [title]="listOfColumn[3].title">
              {{ listOfColumn[3].title }}
            </th>
            <th scope="col" nzWidth="100px" nzRight></th>
          </tr>
          <tr *ngIf="isQuestionForm">
            <th scope="col">
              <nz-form-item>
                <nz-form-control [nzErrorTip]="labelErrorTpl">
                  <input
                    name="question"
                    type="text"
                    nz-input
                    formControlName="customQuestion"
                    placeholder="Enter question" />
                  <ng-template #labelErrorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please enter question.
                    </ng-container>
                    <ng-container *ngIf="control.hasError('maxlength')">
                      Question can not exceed 500 characters.
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </th>
            <th scope="col">
              <nz-form-item>
                <nz-form-control class="checkbox-control">
                  <span
                    nz-checkbox
                    formControlName="isRequired"
                    class="custom-checkbox"></span>
                </nz-form-control>
              </nz-form-item>
            </th>
            <th scope="col">
              <nz-form-item>
                <nz-form-control class="checkbox-control">
                  <span
                    nz-checkbox
                    [nzChecked]="
                      customQuestionForm.get('statusId')?.value === 1
                    "
                    (nzCheckedChange)="
                      customQuestionForm
                        .get('statusId')
                        ?.setValue($event ? 1 : 2)
                    "
                    class="custom-checkbox"></span>
                </nz-form-control>
              </nz-form-item>
            </th>
            <th scope="col">
              <nz-form-item>
                <nz-form-control nzHasFeedback [nzErrorTip]="errorTpl">
                  <nz-select
                    id="reportType"
                    formControlName="questionForReportTypeId"
                    nzPlaceHolder="Select report type"
                    class="template-select">
                    <nz-option
                      *ngFor="let option of reportTypes"
                      [nzLabel]="option.value"
                      [nzValue]="option.id">
                    </nz-option>
                  </nz-select>

                  <ng-template #errorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please select report type.
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </th>
            <th scope="col">
              <nz-form-item>
                <div class="action-btn-wrapper">
                  <button nz-button nzType="text" (click)="onCancel()">
                    Cancel
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    [disabled]="customQuestionForm.invalid"
                    class="primary-text-btn"
                    [disabled]="customQuestionForm.invalid"
                    (click)="onSubmit()">
                    Save
                  </button>
                </div>
              </nz-form-item>
            </th>
          </tr>
        </thead>
        <tbody
          cdkDropList
          [cdkDropListData]="questionList"
          (cdkDropListDropped)="drop($event)">
          <tr *ngFor="let data of questionList; let i = index" cdkDrag>
            <td>
              <button
                nz-button
                nzType="text"
                *ngIf="
                  !isEditMode || editCustomQuestionForm.value.editIndex !== i
                ">
                <svg-icon
                  cdkDragHandle
                  src="/assets/icon/icon-drag.svg"
                  class="icon s-20"
                  aria-label="Drag"></svg-icon>
                {{ data.customQuestion }}
              </button>

              <nz-form-item
                *ngIf="
                  isEditMode && editCustomQuestionForm.value.editIndex === i
                ">
                <nz-form-control [nzErrorTip]="labelErrorTpl">
                  <input
                    name="question"
                    type="text"
                    nz-input
                    formControlName="customQuestion"
                    placeholder="Enter question" />
                  <ng-template #labelErrorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please enter question!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('maxlength')">
                      Question can not exceed 500 characters.
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </td>
            <td nzAlign="center" [title]="data.isRequired ? 'Yes' : 'No'">
              <span
                *ngIf="
                  !isEditMode || editCustomQuestionForm.value.editIndex !== i
                "
                >{{ data.isRequired ? 'Yes' : 'No' }}</span
              >
              <nz-form-item
                *ngIf="
                  isEditMode && editCustomQuestionForm.value.editIndex === i
                ">
                <nz-form-control class="checkbox-control">
                  <span
                    nz-checkbox
                    formControlName="isRequired"
                    class="custom-checkbox"></span>
                </nz-form-control>
              </nz-form-item>
            </td>
            <td nzAlign="center" [title]="data.statusId === 1 ? 'Yes' : 'No'">
              <span
                *ngIf="
                  !isEditMode || editCustomQuestionForm.value.editIndex !== i
                "
                >{{ data.statusId === 1 ? 'Yes' : 'No' }}</span
              >
              <nz-form-item
                *ngIf="
                  isEditMode && editCustomQuestionForm.value.editIndex === i
                ">
                <nz-form-control class="checkbox-control">
                  <span
                    [title]="
                      editCustomQuestionForm.get('statusId')?.value === 1
                        ? 'Click to deactivate this question'
                        : 'Click to activate this question'
                    "
                    nz-checkbox
                    [nzChecked]="
                      editCustomQuestionForm.get('statusId')?.value === 1
                    "
                    (nzCheckedChange)="
                      editCustomQuestionForm
                        .get('statusId')
                        ?.setValue($event ? 1 : 2)
                    "
                    class="custom-checkbox"></span>
                </nz-form-control>
              </nz-form-item>
            </td>
            <td nzAlign="center" [title]="data.questionForReportType">
              <span
                *ngIf="
                  !isEditMode || editCustomQuestionForm.value.editIndex !== i
                "
                >{{ data.questionForReportType }}</span
              >
              <nz-form-item
                *ngIf="
                  isEditMode && editCustomQuestionForm.value.editIndex === i
                ">
                <nz-form-control nzHasFeedback [nzErrorTip]="errorTpl">
                  <nz-select
                    formControlName="questionForReportTypeId"
                    nzPlaceHolder="Select report type"
                    class="template-select">
                    <nz-option
                      *ngFor="let option of reportTypes"
                      [nzLabel]="option.value"
                      [nzValue]="option.id">
                    </nz-option>
                  </nz-select>

                  <ng-template #errorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please select report type!
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </td>
            <td nzRight>
              <div
                class="action-btn-wrapper"
                *ngIf="
                  !isEditMode || editCustomQuestionForm.value.editIndex !== i
                ">
                <button nz-button nzType="text" (click)="editQuestion(i)">
                  <svg-icon
                    [title]="'Edit Question'"
                    src="/assets/icon/icon-edit.svg"
                    class="icon s-20"
                    aria-label="Edit"></svg-icon>
                </button>
              </div>
              <div
                class="action-btn-wrapper"
                *ngIf="
                  isEditMode && editCustomQuestionForm.value.editIndex === i
                ">
                <button nz-button nzType="text" (click)="onCancel()">
                  Cancel
                </button>
                <button
                  nz-button
                  nzType="text"
                  class="primary-text-btn"
                  [disabled]="getFormGroup.invalid"
                  (click)="onSubmit()">
                  Save
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </form>
  </div>
</nz-spin>
